import { SubcontractCOFormItem } from '../../../../Interfaces/Accounting/ACForms.interfaces';

export const checkItem = (item: SubcontractCOFormItem) => {
  const {
    description,
    um,
    phase,
    units,
    unitCosts,
    retainage,
    total,
    invoicedCost,
  } = item;

  if (
    !description ||
    !um ||
    !phase ||
    units == null ||
    unitCosts == null ||
    retainage == null
  ) {
    return 'The form is incomplete! Please fill in the missing fields.';
  }

  if (description?.length > 60) {
    return `The description accepts a maximum of 60 characters!`;
  }

  if (invoicedCost && (total ?? 0) < invoicedCost) {
    return `In item ${item.item}, the Current Costs cannot be lower than the item's Invoiced Costs of $${invoicedCost}!`;
  }

  return false;
};
